import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  signupRedirectSettingsService,
  type SignupRedirectSettings,
  type SignupRedirectUpdateInput,
} from '@/services/settings/signup-redirect-settings.service';

export const signupRedirectSettingsKeys = {
  all: ['provider', 'settings', 'signup-redirect'] as const,
};

export function useSignupRedirectSettings() {
  return useQuery<SignupRedirectSettings>({
    queryKey: signupRedirectSettingsKeys.all,
    queryFn: () => signupRedirectSettingsService.getSettings(),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateSignupRedirectSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: SignupRedirectUpdateInput) =>
      signupRedirectSettingsService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(signupRedirectSettingsKeys.all, settings);
    },
  });
}
